var addValidate = false;
var pageConfig = window.pageConfig;
var i18n = require('i18n');
var util = require('../../app/util');
var addUserLayer = require('./addUserLayer.html');
$('body').append(addUserLayer({
  roles: Object.keys(pageConfig.roleMap || {})
}));


module.exports = function(success) {
  if (addValidate) {
    return;
  }
  addValidate = true;


  var layer = $('.add-user-layer');
  layer.form({
    fields: {
      uid: {
        identifier: 'uid',
        rules: [{
          type: 'empty',
          prompt: i18n('tip.input.username')
        }]
      },
      role: {
        identifier: 'role',
        rules: [{
          type: 'empty',
          prompt: i18n('tip.select.role')
        }]
      }
    },
    onSuccess: function(e, data) {
      var pid = $('.project-list').find('.selected').data('project-id')
      if (!pid) {
        return
      }

      util.loadData('/project/' + pid + '/addUser', data, 'POST', function (res) {
        layer.find('.close').click();
        res.data.nickname = currentSelectName;
        success(res.data);
      });
    }
  });

  layer.find('.close').click(function() {
    layer.find('input').val('');
    layer.modal('hide');
  });


  var cache;
  var currentSelectName;
  layer.find('.ui.search').dropdown({
    onChange: function (value, text, select) {
      currentSelectName = text;
    },
    apiSettings: {
      url: 'queryUsers?key={value}&limit=10',
      action: 'query users',
      throttle: 500,
      beforeSend: function(settings) {
        settings.urlData = {
          value: layer.find('.ui.search .search').val()
        };

        return settings.urlData.value ? settings : false;
      },
      onResponse: function(res) {
        var ret = {
          results: []
        };
        if (!res.success) {
          return cache || ret;
        }

        res.data.forEach(function(item) {
          ret.results.push({
            title: item.nickname,
            name: item.nickname,
            value: item.id,
            uid: item.id
          });
        });
        cache = ret;
        return ret;
      }
    },
    showOnFocus: false,
    message: {
      noResults: i18n('tip.no.results')
    }
  });


  layer.find('.dropdown.role').dropdown({
    onChange: function(value, text) {}
  });

  layer.modal({
    onHide: function () {
      layer.form('reset');
    }
  });
}


// WEBPACK FOOTER //
// ./src/pages/home/addUserLayer.js